import { render, staticRenderFns } from "./newsItem.vue?vue&type=template&id=85547fa8&scoped=true&"
import script from "./newsItem.vue?vue&type=script&lang=js&"
export * from "./newsItem.vue?vue&type=script&lang=js&"
import style0 from "./newsItem.vue?vue&type=style&index=0&id=85547fa8&scoped=true&lang=css&"
import style1 from "./newsItem.vue?vue&type=style&index=1&id=85547fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85547fa8",
  null
  
)

export default component.exports